import { createSlice } from "@reduxjs/toolkit";
import {
  AllClientsThunk,
  GetSingleClientThunk,
  AddClientThunk,
  UpdateClientThunk,
  DeleteClientThunk,
} from "./thunk";

const initialState = {
  clients: [],
  singleClient: null,
  loading: false,
  error: null,
  successMessage: null,
};

const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    clearClientState: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* -------------------- GET ALL -------------------- */
      .addCase(AllClientsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AllClientsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.clients = action.payload?.data || [];
      })
      .addCase(AllClientsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- GET SINGLE -------------------- */
      .addCase(GetSingleClientThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetSingleClientThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.singleClient = action.payload?.data || null;
      })
      .addCase(GetSingleClientThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- ADD -------------------- */
      .addCase(AddClientThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddClientThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Client added successfully!";
      })
      .addCase(AddClientThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- UPDATE -------------------- */
      .addCase(UpdateClientThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateClientThunk.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = "Client updated successfully!";
      })
      .addCase(UpdateClientThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------------------- DELETE -------------------- */
      .addCase(DeleteClientThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(DeleteClientThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.clients = state.clients.filter(
          (c) => c.uuid !== action.payload.uuid
        );
        state.successMessage = action.payload.message;
      })
      .addCase(DeleteClientThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearClientState } = clientsSlice.actions;
export default clientsSlice.reducer;
